import { Controller } from "@hotwired/stimulus"

// Shared lightbox state (module-level, one instance per page)
let lbModal = null
let lbPhotos = []
let lbIndex = 0

function lbShow(photos, index) {
  lbPhotos = photos
  lbIndex = index
  lbUpdate()
  lbModal.showModal()
}

function lbUpdate() {
  const img = document.getElementById("lbImg")
  const counter = document.getElementById("lbCounter")
  const prev = document.getElementById("lbPrev")
  const next = document.getElementById("lbNext")
  if (img) img.src = lbPhotos[lbIndex]
  if (counter) counter.textContent = lbPhotos.length > 1 ? `${lbIndex + 1} / ${lbPhotos.length}` : ""
  if (prev) prev.style.display = lbPhotos.length > 1 ? "" : "none"
  if (next) next.style.display = lbPhotos.length > 1 ? "" : "none"
}

function lbNext() { lbIndex = (lbIndex + 1) % lbPhotos.length; lbUpdate() }
function lbPrev() { lbIndex = (lbIndex - 1 + lbPhotos.length) % lbPhotos.length; lbUpdate() }

function ensureLightbox() {
  if (lbModal) return
  if (document.getElementById("photoLightbox")) {
    lbModal = document.getElementById("photoLightbox")
    return
  }

  const el = document.createElement("dialog")
  el.id = "photoLightbox"
  el.className = "kit-lightbox"
  el.innerHTML = `
    <button type="button" id="lbClose" class="kit-lightbox__close">&times;</button>
    <button type="button" id="lbPrev" class="kit-lightbox__nav kit-lightbox__nav--prev">&#8249;</button>
    <img id="lbImg" src="" alt="" draggable="false" class="kit-lightbox__img">
    <button type="button" id="lbNext" class="kit-lightbox__nav kit-lightbox__nav--next">&#8250;</button>
    <div id="lbCounter" class="kit-lightbox__counter"></div>
  `
  document.body.appendChild(el)
  lbModal = el

  el.addEventListener("click", e => { if (e.target === el) el.close() })
  document.getElementById("lbClose").addEventListener("click", () => el.close())
  document.getElementById("lbPrev").addEventListener("click", lbPrev)
  document.getElementById("lbNext").addEventListener("click", lbNext)

  // Touch swipe
  let touchStartX = 0
  el.addEventListener("touchstart", e => { touchStartX = e.changedTouches[0].clientX }, { passive: true })
  el.addEventListener("touchend", e => {
    const dx = e.changedTouches[0].clientX - touchStartX
    if (Math.abs(dx) > 50) dx < 0 ? lbNext() : lbPrev()
  }, { passive: true })

  // Keyboard
  document.addEventListener("keydown", e => {
    if (!lbModal.open) return
    if (e.key === "ArrowLeft") lbPrev()
    if (e.key === "ArrowRight") lbNext()
  })
}

export default class extends Controller {
  static targets = ["newList", "fileInput"]

  pendingFiles = [] // { file, dataUrl, uid }
  nextUid = 0

  connect() {
    ensureLightbox()
  }

  addFiles(event) {
    Array.from(event.target.files).forEach(file => {
      if (!file.type.startsWith("image/")) return
      const uid = this.nextUid++
      const reader = new FileReader()
      reader.onload = e => {
        this.pendingFiles.push({ file, dataUrl: e.target.result, uid })
        this.renderNewPhotos()
      }
      reader.readAsDataURL(file)
    })
    // Reset so the same file can be selected again
    event.target.value = ""
  }

  renderNewPhotos() {
    this.newListTarget.innerHTML = ""
    this.pendingFiles.forEach(pf => {
      const wrapper = document.createElement("div")
      wrapper.className = "kit-photo-thumb"
      wrapper.innerHTML = `
        <img src="${pf.dataUrl}"
             data-photo-src="${pf.dataUrl}"
             data-action="click->acceptance-photos#openLightbox">
        <button type="button"
                class="kit-photo-thumb__remove"
                data-uid="${pf.uid}"
                data-action="click->acceptance-photos#removeNewPhoto">
          &times;
        </button>
      `
      this.newListTarget.appendChild(wrapper)
    })
    this.syncFileInput()
  }

  removeNewPhoto(event) {
    event.stopPropagation()
    const uid = parseInt(event.currentTarget.dataset.uid)
    this.pendingFiles = this.pendingFiles.filter(pf => pf.uid !== uid)
    this.renderNewPhotos()
  }

  syncFileInput() {
    if (!this.hasFileInputTarget) return
    const dt = new DataTransfer()
    this.pendingFiles.forEach(pf => dt.items.add(pf.file))
    this.fileInputTarget.files = dt.files
  }

  async deleteExistingPhoto(event) {
    event.stopPropagation()
    const wrapper = event.currentTarget.closest("[data-delete-url]")
    if (!wrapper) return
    const url = wrapper.dataset.deleteUrl
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const res = await fetch(url, {
        method: "DELETE",
        headers: { "X-CSRF-Token": csrfToken, "Accept": "application/json" }
      })
      if (res.ok) {
        wrapper.remove()
      }
    } catch (err) {
      console.error("Failed to delete photo", err)
    }
  }

  openLightbox(event) {
    const allImgs = Array.from(this.element.querySelectorAll("[data-photo-src]"))
    const photos = allImgs.map(el => el.dataset.photoSrc)
    const clickedSrc = event.currentTarget.dataset.photoSrc
    const index = Math.max(0, allImgs.findIndex(el => el.dataset.photoSrc === clickedSrc))
    lbShow(photos, index)
  }
}
